import { supabase } from "@/integrations/supabase/client";

/**
 * Reads the HubSpot tracking cookie (hubspotutk). HubSpot needs this value
 * (as context.hutk) to link a form submission to an existing contact.
 */
export const getHubspotUtk = (): string | undefined => {
  if (typeof document === "undefined") return undefined;
  const match = document.cookie.match(/(?:^|;\s*)hubspotutk=([^;]+)/);
  return match ? decodeURIComponent(match[1]) : undefined;
};

let trackingLoaded = false;

/**
 * Loads the HubSpot tracking script so the hubspotutk cookie gets set.
 * The portal ID is served by the submit-contact-form function (GET) so we
 * don't have to hardcode it in the frontend.
 */
export const loadHubSpotTracking = async (): Promise<void> => {
  if (trackingLoaded || typeof document === "undefined") return;
  if (document.getElementById("hs-script-loader")) {
    trackingLoaded = true;
    return;
  }

  try {
    const { data, error } = await supabase.functions.invoke<{ portalId?: string }>(
      "submit-contact-form",
      { method: "GET" }
    );
    if (error || !data?.portalId) return;

    const script = document.createElement("script");
    script.id = "hs-script-loader";
    script.type = "text/javascript";
    script.async = true;
    script.defer = true;
    script.src = `https://js.hs-scripts.com/${data.portalId}.js`;
    script.onerror = () => {
      // Fall back to the EU tracking domain for EU-hosted portals
      const fallback = document.createElement("script");
      fallback.id = "hs-script-loader-fallback";
      fallback.async = true;
      fallback.defer = true;
      fallback.src = `https://js-eu1.hs-scripts.com/${data.portalId}.js`;
      document.body.appendChild(fallback);
    };
    document.body.appendChild(script);
    trackingLoaded = true;
  } catch (e) {
    console.warn("HubSpot tracking script could not be loaded", e);
  }
};
